import * as React from 'react';

export type GMetrixStackedProgressBarItem = {
    color: string;
    title?: string;
    value: number;
};

type GMetrixStackedProgressBarProps = {
    data: GMetrixStackedProgressBarItem[];
    label?: string;
};

export const GMetrixStackedProgressBar = (props: GMetrixStackedProgressBarProps) => {

    const { data, label } = props;

    const total = data.reduce((sum, item) => sum + item.value, 0) || 1;

    return (
        <div>
            {label && (
                <div className="text-center fw-bold mb-1">
                    {label}
                </div>
            )}
            <div className="progress" style={{ height: '24px' }}>
                {data.map((item, index) => {

                    const widthPct = (item.value / total) * 100;

                    return (
                        <div
                            aria-valuemax={100}
                            aria-valuemin={0}
                            aria-valuenow={widthPct}
                            className="progress-bar"
                            key={index}
                            role="progressbar"
                            style={{ background: item.color, width: `${widthPct}%` }}
                            title={item.title ? `${item.title}: ${item.value}` : String(item.value)}
                        />
                    );

                })}
            </div>
        </div>
    );

};
